import { FormControlLabel, Switch } from '@mui/material'
import React from 'react'

import { ActionContext } from '@/app/module/campaigns/utils/actions/types'

import AiUsageHelper from './ai-usage-helper'

type Props = {
  context: ActionContext.OnAnswer | ActionContext.OpenEnded
  transcribe: boolean
  onChange: (value: boolean) => void
}

const WhatsAppTranscribeToggle: React.FC<Props> = ({ transcribe, onChange }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked),
    [onChange],
  )

  return (
    <div>
      <FormControlLabel
        className="whatsapp-transcribe-toggle"
        control={<Switch checked={!!transcribe} onChange={handleChange} />}
        label="Transcribe voice clips replies with AI"
      />
      <AiUsageHelper text="We use AI to transcribe the audio to text." />
    </div>
  )
}

export default WhatsAppTranscribeToggle
